import { Post } from "../utils/http"

export function getComm(params, config = {}) {
  return Post("/api/terns/init", params, config)
}
export function getStoreInfo(params) {
  return Post("/api/terns/storeInfo", params)
}
